
<div class="t-content" id="flights" [ngStyle]="{'margin-bottom': componentResults ? '70px' : '35px'}">

    <div *ngIf="componentResults" class="d-flex justify-content-between align-items-center mb-4 mt-3">
    <div class="d-flex align-items-center" style="gap: 1em;">
        <img src="../../../../../assets/img/app/categories-search-box/AEREO.svg" style="width: 24px" alt="">
        <h3 class="mb-0 ml-2" style="font-family: 'Rubik', serif">Editar búsqueda de vuelos</h3>
    </div>
    <div>
        <button type="button" class="close btn-closed" aria-label="Close" (click)="close()">
          <span aria-hidden="true" style="font-size: 50px !important; font-weight: 100 !important;">&times;</span>
        </button>
    </div>
  </div>

  <div *ngIf="componentResults && loadingData"
       class="loading-container d-flex flex-column align-items-center justify-content-center py-5 mt-3">


    <div class="logo-loading mb-4">
      <img [src]="agencyImagen"
           alt="Logo"
           class="loading-logo animate__animated animate__pulse animate__infinite">
    </div>


    <div class="text-center animate__animated animate__fadeIn">
      <h4 class="text-muted mb-3">Cargando información, gracias por esperar...</h4>


      <div [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1}" class="spinner-border" role="status">
      </div>
    </div>
  </div>

  <form *ngIf="!loadingData" (ngSubmit)="_onSubmit(_form, $event)" [formGroup]="_form" novalidate>
    <div class="d-flex pb-3 pt-3" style="gap: .5em;">
      <!-- <select name="" id=""
              class="px-2"
              style="border-radius: 6px;height: 32px;font-family: 'Rubik', sans-serif !important;font-size: 12px !important;font-weight: 400 !important;"
              [ngStyle]="{
                          'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_1 +'22',
                          'border': '1px solid ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_1,
                          'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1
                         }"
              (change)="changeWay($event.target.value)"
                         >
        <ng-container *ngFor="let way of wayArr">
          <option
                  class="px-2"
                  style="font-family: 'Rubik', sans-serif !important;font-size: 12px !important;font-weight: 400 !important;"
                  [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                  value="{{way.value}}">{{way.label}}</option>
        </ng-container>
      </select> -->

      <ng-container *ngFor="let way of wayArr">
        <button
                type="button"
                class="btn btn-way"
                [class.active]="selectedWay === way?.value"
                (click)="changeWay(way?.value)"
                > <p>{{way.label}}</p></button>
      </ng-container>

      <div class="d-flex align-items-center w-100 position-relative justify-content-between"  id="form-destination" *ngIf="legsFormArray.length > 0">

          <div class="position-relative" style="flex: 1; min-width: 0;">
            <input type="text"
                    name="origen-0"
                    matInput
                    maxlength="50"
                    class="form-control input-search-box"
                    style="background-color: white;"
                    #originWay
                    [formControl]="$any(legsFormArray.at(0).get('origin'))"
                    [attr.disabled]="selectedWay === 'multi' ? true : null"
                    placeholder="Origen (Aeropuerto, Ciudad)"
                    [matAutocomplete]="originWayAuto"
                    #originWayTrigger="matAutocompleteTrigger"
                    (input)="onLocationInput($event, originWayTrigger, 'origin', 0)"
            >

            <mat-autocomplete #originWayAuto="matAutocomplete"
                              [displayWith]="displayFn"
                              (optionSelected)="selectLocation($event.option.value, 'origin', 0)">

                 <ng-container *ngIf="originOptionsLegs[0] as options">

                  <!-- AEROPUERTOS -->
                  <ng-container *ngFor="let item of options">
                    <ng-container *ngIf="item.type === 'airport'">
                      <mat-option disabled style="background-color: #f4f4f4;height: 42px;" *ngIf="item.airports && item.airports.length > 0">
                          <div class="d-flex justify-content-between">
                            <div class="d-flex align-items-center" style="gap: 0.25em;">
                              <img src="../../../../assets/icons/search-box/avion_gris.svg" style="width: 35px; height: 35px;">
                              <span class="mt-1" style="font-family: 'Rubik', serif; font-size: 13px !important; font-weight: 600 !important;">Aeropuerto</span>
                            </div>
                            <div>
                              <span style="font-family: 'Rubik', serif; font-size: 11px !important; font-weight: 400 !important;">{{item.airports.length}} resultados</span>
                            </div>
                          </div>
                      </mat-option>
                      <ng-container *ngFor="let airport of item.airports">
                        <mat-option [value]="{data: airport, type: item.type}">
                          <div style="margin-left: 2.4em;">
                            <p class="mb-0" style="font-family: 'Rubik'; font-size: 14px !important; font-weight: 400 !important; line-height: 1;">{{ capitalize(airport.name) }},
                            <span class="mb-0" style="font-family: 'Rubik'; font-size: 12px !important; line-height: 1;font-weight: 400 !important;">
                              {{ capitalize(airport.country_name) }} <span style="font-weight: 600 !important;">({{airport.iata}})</span>
                            </span></p>
                          </div>
                        </mat-option>
                      </ng-container>
                    </ng-container>
                  </ng-container>

                 </ng-container>

            </mat-autocomplete>
            <span
              style="color: red; font-family: 'Poppins'; font-size: 10px !important; position: absolute; bottom: -16px; left: 10px; line-height: 1;"
              *ngIf="legsFormArray.at(0).get('origin').touched && legsFormArray.at(0).get('origin').hasError('required')"
            >Este campo es requerido. Seleccione un origen válido de la lista.</span>
          </div>

                     <div class="container-button-transfer-destination" [style.pointer-events]="selectedWay === 'multi' ? 'none' : 'auto'" [style.opacity]="selectedWay === 'multi' ? 0.4 : 1">
            <div class="position-relative group-button-transfer-destination">

              <i
                role="button"
                tabindex="0"
                class="bi bi-circle-fill circle-btn"
                [ngStyle]="{
                            'text-shadow': isHovered ? '0px 0px 5px ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_1 : ''
                              }"
                (mouseenter)="isHovered = true"
                (mouseleave)="isHovered = false"
                (click)="swapLocations(0)"
              ></i>
              <i
                  role="button"
                  tabindex="0"
                  class="bi bi-arrow-left-right swap-btn"
                  (click)="swapLocations(0)"
                  [ngStyle]="{
                              'color': isHovered ?  getClientsSettingAppBooking?.clients_setting_global?.color_main_1 : ''
                              }"
                  (mouseenter)="isHovered = true"
                  (mouseleave)="isHovered = false"
              ></i>
            </div>
         </div>

          <div class="position-relative" style="flex: 1; min-width: 0;">
            <input type="text"
                    name="destino-0"
                    matInput
                    maxlength="50"
                    class="form-control input-search-box"
                    style="background-color: white;margin-left:.25em;"
                    #destinationWay
                    [formControl]="$any(legsFormArray.at(0).get('destination'))"
                    [attr.disabled]="selectedWay === 'multi' ? true : null"
                    placeholder="Destino (Aeropuerto, Ciudad)"
                    [matAutocomplete]="destinationWayAuto"
                    #destinationWayTrigger="matAutocompleteTrigger"
                    (input)="onLocationInput($event, destinationWayTrigger, 'destination', 0)"
            >

             <mat-autocomplete #destinationWayAuto="matAutocomplete"
                              [displayWith]="displayFn"
                              (optionSelected)="selectLocation($event.option.value, 'destination', 0)">


                <ng-container *ngIf="destinationOptionsLegs[0] as options">

                  <ng-container *ngFor="let item of options">
                    <ng-container *ngIf="item.type === 'airport'">
                      <mat-option disabled style="background-color: #f4f4f4;height: 42px;" *ngIf="item.airports && item.airports.length > 0">
                          <div class="d-flex justify-content-between">
                            <div class="d-flex align-items-center" style="gap: 0.25em;">
                              <img src="../../../../assets/icons/search-box/avion_gris.svg" style="width: 35px; height: 35px;">
                              <span class="mt-1" style="font-family: 'Rubik', serif; font-size: 13px !important; font-weight: 600 !important;">Aeropuerto</span>
                            </div>
                            <div>
                              <span style="font-family: 'Rubik', serif; font-size: 11px !important; font-weight: 400 !important;">{{item.airports.length}} resultados</span>
                            </div>
                          </div>
                      </mat-option>
                      <ng-container *ngFor="let airport of item.airports">
                        <mat-option [value]="{data: airport, type: item.type}">
                          <div style="margin-left: 2.4em;">
                            <p class="mb-0" style="font-family: 'Rubik'; font-size: 14px !important; font-weight: 400 !important; line-height: 1;">{{ capitalize(airport.name) }},
                            <span class="mb-0" style="font-family: 'Rubik'; font-size: 12px !important; line-height: 1;font-weight: 400 !important;">
                              {{ capitalize(airport.country_name) }} <span style="font-weight: 600 !important;">({{airport.iata}})</span>
                            </span></p>
                          </div>
                        </mat-option>
                      </ng-container>
                    </ng-container>
                  </ng-container>



                </ng-container>

             </mat-autocomplete>
            <span
              style="color: red; font-family: 'Poppins'; font-size: 10px !important; position: absolute; bottom: -16px; left: 10px; line-height: 1;"
              *ngIf="legsFormArray.at(0).get('destination').touched && legsFormArray.at(0).get('destination').hasError('required')"
            >Este campo es requerido. Seleccione un destino válido de la lista.</span>
          </div>

    </div>
    </div>
    <!-- TRAMO ÚNICO: Ida / Ida y vuelta -->
    <div class="d-flex pb-3 pt-3" style="gap: .5em;" *ngIf="selectedWay !== 'multi' && legsFormArray.length > 0">

      <div id="form-destination " style="width:42%;position: relative">
        <select
          formControlName="cabinClass"
          class="form-control input-search-box select-style"
          style="height: 100%;"
        >
          <option value="">Clase de cabina</option>
          <ng-container *ngFor="let cabin of cabinClassArr">
            <option [value]="cabin.value">{{ cabin.label }}</option>
          </ng-container>
        </select>

        <img
            width="10"
            height="10"
            style="position: absolute; right: 1em; top: 30%"
            src="../../../../../assets/img/app/little-icons/arrow-down-black.svg"
          />
      </div>

      <div  id="form-destination" [ngStyle]="{'width': selectedWay === 'twoWay' ? '35%' : '30%'}">
         <div class="position-relative">
           <button
            #triggerButton
            type="button"
            class="form-control btn-usb-rp d-flex align-items-center justify-content-between element-config-passenger"
            (click)="_openModal();"
            [attr.aria-expanded]="!isCollapsed"
            aria-controls="false"
          >
            <p class="p-0 m-0 align-self-center align-middle font-poppins text-passenger-input"> {{ passengers }}</p>

            <img width="10" height="10" src="../../../../../assets/img/app/little-icons/arrow-down-black.svg" />
          </button>

          <div
            (collapsed)="clickOutside($event)"
            (expanded)="($event)"
            [collapse]="!isCollapsed || _close"
            (click)="_over()"
            class="config-passenger"
          >
            <div class="row">
              <div style="position: relative; width: 100%">
                <div
                  #cardSelectorRoom
                  id="cardSelectorRoom"
                  class="card py-4 px-4 scrollable-card-container"
                  style="width: auto !important; min-width: 100%"
                >
                  <div class="room-content">
                    <div class="d-flex flex-row col-12 align-items-center justify-content-between p-2">
                      <div class="d-flex flex-column">
                        <div class="d-flex flex-row align-items-start justify-content-between p-0 pb-3" formGroupName="passengers">
                          <div class="d-flex flex-column align-items-center p-0 m-0 mr-2 ml-3">
                            <div class="d-flex flex-column align-items-start mb-3">
                              <label class="mb-0" style="font-family: 'Rubik' !important; font-size: 14px !important; font-weight: 600 !important; line-height: 1;" for="adults">Adultos</label>
                              <p class="mb-0" style="font-family: 'Rubik' !important; font-size: 11px !important; font-weight: 400 !important; line-height: 1;">+ de 18 años</p>
                            </div>
                            <div class="input-group justify-content-end" style="max-width: 200px; width: 100%; min-width: 91px">
                              <button type="button" class="pr-2" style="border: none; background-color: transparent;" (click)="decrementPassengerAdult($event)" [disabled]="getPassengerCountAdult() <= 1">
                                <p class="mb-0" style="font-size: 20px; font-weight: 700 !important;">-</p>
                              </button>
                              <input
                                type="number"
                                class="form-control text-center"
                                style="border-radius: 8px; max-width: 45px; padding: 0 !important;"
                                [value]="getPassengerCountAdult()"
                                [min]="1"
                                [max]="10"
                                (change)="validatePassengerInput($event)"
                                (keydown)="handleAdultInput($event)"
                                (blur)="handleAdultBlur($event)"
                                (click)="preventModalClose($event)"
                                name="adults"
                              />
                              <button type="button" class="pl-2" style="border: none; background-color: transparent;" (click)="incrementPassengerAdult($event)" [disabled]="getPassengerCountAdult() >= 10">
                                <p class="mb-0" style="font-size: 20px; font-weight: 700 !important;">+</p>
                              </button>
                            </div>
                          </div>
                          <div class="d-flex flex-column align-items-center p-0 m-0 mr-3 ml-2">
                            <div class="container-label d-flex mb-3">
                              <div class="d-flex flex-column align-items-start">
                                <label class="mb-0" style="font-family: 'Rubik' !important; font-size: 14px !important; font-weight: 600 !important; line-height: 1;" for="childs">Niños</label>
                                <p class="mb-0" style="font-family: 'Rubik' !important; font-size: 11px !important; font-weight: 400 !important; line-height: 1;">- de 18 años</p>
                              </div>
                            </div>
                            <div class="input-group justify-content-end" style="max-width: 200px; width: 100%; min-width: 91px">
                              <button type="button" style="border: none; background-color: transparent;" class="pr-2" (click)="decrementPassengerChildren($event)" [disabled]="getPassengerCountChildren() <= 0">
                                <p class="mb-0" style="font-size: 20px; font-weight: 700 !important;">-</p>
                              </button>
                              <input
                                type="number"
                                class="form-control text-center"
                                style="border-radius: 8px; max-width: 45px; padding: 0 !important;"
                                [value]="getPassengerCountChildren()"
                                [min]="0"
                                [max]="10"
                                (change)="validatePassengerInput($event)"
                                (keydown)="handleChildrenInput($event)"
                                (blur)="handleChildrenBlur($event)"
                                (click)="preventModalClose($event)"
                                name="children"
                              />
                              <button type="button" style="border: none; background-color: transparent;" class="pl-2" (click)="incrementPassengerChildren($event)" [disabled]="getPassengerCountChildren() >= 10">
                                <p class="mb-0" style="font-size: 20px; font-weight: 700 !important;">+</p>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="formArray(passengersGroup, 'childsage').length > 0" formGroupName="passengers" class="d-flex flex-column p-4 m-0" style="border-radius: 10px; background-color: #f4f4f4;">
                          <div class="d-flex flex-column align-items-start mb-3 ml-1">
                            <label class="mb-0" style="font-family: 'Rubik' !important; font-size: 14px !important; font-weight: 600 !important; line-height: 1; text-wrap: nowrap;">Edad niños <span style="font-weight: 400 !important;">- de 18 años</span></label>
                          </div>
                          <div class="d-flex mb-4 flex-wrap">
                            <div formArrayName="childsage" *ngFor="let age of formArray(passengersGroup, 'childsage'); let j = index">
                              <label [formGroupName]="j" class="p-0 ml-1" style="position: relative;">
                                <select
                                  name="age"
                                  formControlName="age"
                                  [ngStyle]="{'margin-left': j > 0 ? '1em' : ''}"
                                  class="form-control custom-select-arrow"
                                  style="height: 35px !important; padding: 0 !important; width: 60px !important; font-family: 'Rubik' !important; font-size: 14px !important; font-weight: 600 !important; text-align: left; padding-left: 13px !important; background-color: #FFFFFF !important; border-radius: 12px;"
                                >
                                  <ng-container *ngFor="let value of agesChildsArr()">
                                    <option value="{{ value }}">{{ value }}</option>
                                  </ng-container>
                                </select>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex flex-row justify-content-end py-2">
                          <div class="py-2 justify-content-end">
                            <button
                              (click)="_confirm()"
                              [attr.aria-expanded]="!isCollapsed"
                              aria-controls="false"
                              class="badge btn-choice-confirm"
                              style="border: none; min-width: 145px; width: 100%; height: 36px;"
                              type="button"
                              [ngStyle]="{'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                            >
                              Confirmar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
         </div>
      </div>

      <div  id="form-destination" style="width:25%">
          <div class="position-relative">
             <input
                  [formControl]="$any(legsFormArray.at(0).get('date'))"
                  type="text"
                  class="form-control input-search-box"
                  id="departureDate"
                  placeholder="{{selectedNoDateDefined ? 'Sin fecha' : 'Salida'}}"
                  autocomplete="off"
                  bsDatepicker
                  [minDate]="now"
                  [bsConfig]="dpConfig"
                  readonly
                  [ngStyle]="{':host tr.ng-star-inserted td.active.start-date.available::after': {'background': getClientsSettingAppBooking?.clients_setting_global?.color_main_1},
                              ':host tr.ng-star-inserted td.active.end-date.available::before': {'background': getClientsSettingAppBooking?.clients_setting_global?.color_main_1}}"
                />
          </div>
      </div>
      <div  id="form-destination" style="width:25%">
          <div class="position-relative">
                <input
                  formControlName="returnDate"
                  type="text"
                  class="form-control input-search-box"
                  id="returnDate"
                  placeholder="{{selectedNoDateDefined ? 'Sin fecha' : 'Regreso'}}"
                  autocomplete="off"
                  bsDatepicker
                  [minDate]="minReturnDate"
                  [bsConfig]="dpConfig"
                  readonly
                  [attr.disabled]="selectedWay !== 'twoWay' ? true : null"
                  [ngStyle]="{':host tr.ng-star-inserted td.active.start-date.available::after': {'background': getClientsSettingAppBooking?.clients_setting_global?.color_main_1},
                              ':host tr.ng-star-inserted td.active.end-date.available::before': {'background': getClientsSettingAppBooking?.clients_setting_global?.color_main_1}}"
                />
          </div>
      </div>


      <div id="form-destination" class="d-flex mb-3" *ngIf="userService.itineraryActive">

          <button *ngIf="!userService._isGuest && userService.itineraryActive.length === 0"
                  class="btn btn-search-hotel d-flex justify-content-center align-items-center inp"
                  (click)="fileActive()"
                  [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                  type="button">
            <span>BUSCAR</span>
          </button>
          <button *ngIf="!userService._isGuest && userService.itineraryActive.length > 0 && validateButtonSearch"
                class="btn btn-search-hotel d-flex justify-content-center align-items-center inp w-100"
                (click)="filePaid()"
                [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                type="button">
          <span>BUSCAR</span>
        </button>
          <button *ngIf="userService._isGuest || (userService.itineraryActive.length > 0 && !validateButtonSearch)"
                  class="btn btn-search-hotel d-flex justify-content-center align-items-center inp"
                  [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                  [disabled]="!_form.valid"
                  type="submit">
            <span>BUSCAR</span>
          </button>
    </div>

    </div>

    <!-- MULTIDESTINO: un tramo por fila, con posibilidad de agregar más -->
    <ng-container *ngIf="selectedWay === 'multi'">
      <ng-container *ngFor="let leg of legsFormArray.controls; let i = index">
        <div class="d-flex align-items-center mb-3 mt-3" style="gap: .5em;">
          <div class="d-flex align-items-center w-100 position-relative justify-content-between"  id="form-destination" >

            <div class="position-relative" style="flex: 1; min-width: 0;">
                <input type="text"
                        name="origen-{{i}}"
                        matInput
                        maxlength="50"
                        class="form-control input-search-box"
                        style="background-color: white;"
                        #originMulti
                        [formControl]="$any(leg.get('origin'))"
                        placeholder="Origen (Aeropuerto, Ciudad)"
                        [matAutocomplete]="originMultiAuto"
                        #originMultiTrigger="matAutocompleteTrigger"
                        (input)="onLocationInput($event, originMultiTrigger, 'origin', i)"
                >

                <mat-autocomplete #originMultiAuto="matAutocomplete"
                                  [displayWith]="displayFn"
                                  (optionSelected)="selectLocation($event.option.value, 'origin', i)">

                     <ng-container *ngIf="originOptionsLegs[i] as options">

                      <ng-container *ngFor="let item of options">
                        <ng-container *ngIf="item.type === 'airport'">
                          <mat-option disabled style="background-color: #f4f4f4;height: 42px;" *ngIf="item.airports && item.airports.length > 0">
                              <div class="d-flex justify-content-between">
                                <div class="d-flex align-items-center" style="gap: 0.25em;">
                                  <img src="../../../../assets/icons/search-box/avion_gris.svg" style="width: 35px; height: 35px;">
                                  <span class="mt-1" style="font-family: 'Rubik', serif; font-size: 13px !important; font-weight: 600 !important;">Aeropuerto</span>
                                </div>
                                <div>
                                  <span style="font-family: 'Rubik', serif; font-size: 11px !important; font-weight: 400 !important;">{{item.airports.length}} resultados</span>
                                </div>
                              </div>
                          </mat-option>
                          <ng-container *ngFor="let airport of item.airports">
                            <mat-option [value]="{data: airport, type: item.type}">
                              <div style="margin-left: 2.4em;">
                                <p class="mb-0" style="font-family: 'Rubik'; font-size: 14px !important; font-weight: 400 !important; line-height: 1;">{{ capitalize(airport.name) }},
                                <span class="mb-0" style="font-family: 'Rubik'; font-size: 12px !important; line-height: 1;font-weight: 400 !important;">
                                  {{ capitalize(airport.country_name) }} <span style="font-weight: 600 !important;">({{airport.iata}})</span>
                                </span></p>
                              </div>
                            </mat-option>
                          </ng-container>
                        </ng-container>
                      </ng-container>

                      <ng-container *ngFor="let item of options">
                        <ng-container *ngIf="item.type === 'city'">
                          <mat-option disabled style="background-color: #f4f4f4;height: 42px;" *ngIf="item.cities && item.cities.length > 0">
                            <div class="d-flex justify-content-between">
                              <div class="d-flex align-items-center" style="gap: 0.25em;">
                                <img src="../../../../assets/icons/search-box/ubicacion_gris.svg" style="width: 35px; height: 35px;">
                                <span class="mt-1" style="font-family: 'Rubik', serif; font-size: 13px !important; font-weight: 600 !important;">Ubicación</span>
                              </div>
                              <div>
                                <span style="font-family: 'Rubik', serif; font-size: 11px !important; font-weight: 400 !important;">{{item.cities.length}} resultados</span>
                              </div>
                            </div>
                          </mat-option>
                          <ng-container *ngFor="let city of item.cities">
                            <mat-option [value]="{data: city, type: item.type}">
                              <div style="margin-left: 2.4em;">
                                <p class="mb-0" style="font-family: 'Rubik'; font-size: 14px !important; font-weight: 600 !important; line-height: 1;">{{ capitalize(city.main_text) }},
                                <span class="mb-0" style="font-family: 'Rubik'; font-size: 12px !important; line-height: 1;font-weight: 400 !important;">{{ capitalize(city.secondary_text) }}</span>
                                </p>
                              </div>
                            </mat-option>
                          </ng-container>
                        </ng-container>
                      </ng-container>

                     </ng-container>

                </mat-autocomplete>
                <span
                  style="color: red; font-family: 'Poppins'; font-size: 10px !important; position: absolute; bottom: -16px; left: 10px; line-height: 1;"
                  *ngIf="leg.get('origin').touched && leg.get('origin').hasError('required')"
                >Este campo es requerido. Seleccione un origen válido de la lista.</span>
            </div>

                         <div class="container-button-transfer-destination">
                <div class="position-relative group-button-transfer-destination">
                  <i
                    role="button"
                    tabindex="0"
                    class="bi bi-circle-fill circle-btn"
                    (click)="swapLocations(i)"
                  ></i>
                  <i
                      role="button"
                      tabindex="0"
                      class="bi bi-arrow-left-right swap-btn"
                      (click)="swapLocations(i)"
                  ></i>
                </div>
             </div>

            <div class="position-relative" style="flex: 1; min-width: 0;">
                <input type="text"
                        name="destino-{{i}}"
                        matInput
                        maxlength="50"
                        class="form-control input-search-box"
                        style="background-color: white;margin-left:.25em;"
                        #destinationMulti
                        [formControl]="$any(leg.get('destination'))"
                        placeholder="Destino (Aeropuerto, Ciudad)"
                        [matAutocomplete]="destinationMultiAuto"
                        #destinationMultiTrigger="matAutocompleteTrigger"
                        (input)="onLocationInput($event, destinationMultiTrigger, 'destination', i)"
                >

                 <mat-autocomplete #destinationMultiAuto="matAutocomplete"
                                  [displayWith]="displayFn"
                                  (optionSelected)="selectLocation($event.option.value, 'destination', i)">

                    <ng-container *ngIf="destinationOptionsLegs[i] as options">

                      <ng-container *ngFor="let item of options">
                        <ng-container *ngIf="item.type === 'airport'">
                          <mat-option disabled style="background-color: #f4f4f4;height: 42px;" *ngIf="item.airports && item.airports.length > 0">
                              <div class="d-flex justify-content-between">
                                <div class="d-flex align-items-center" style="gap: 0.25em;">
                                  <img src="../../../../assets/icons/search-box/avion_gris.svg" style="width: 35px; height: 35px;">
                                  <span class="mt-1" style="font-family: 'Rubik', serif; font-size: 13px !important; font-weight: 600 !important;">Aeropuerto</span>
                                </div>
                                <div>
                                  <span style="font-family: 'Rubik', serif; font-size: 11px !important; font-weight: 400 !important;">{{item.airports.length}} resultados</span>
                                </div>
                              </div>
                          </mat-option>
                          <ng-container *ngFor="let airport of item.airports">
                            <mat-option [value]="{data: airport, type: item.type}">
                              <div style="margin-left: 2.4em;">
                                <p class="mb-0" style="font-family: 'Rubik'; font-size: 14px !important; font-weight: 400 !important; line-height: 1;">{{ capitalize(airport.name) }},
                                <span class="mb-0" style="font-family: 'Rubik'; font-size: 12px !important; line-height: 1;font-weight: 400 !important;">
                                  {{ capitalize(airport.country_name) }} <span style="font-weight: 600 !important;">({{airport.iata}})</span>
                                </span></p>
                              </div>
                            </mat-option>
                          </ng-container>
                        </ng-container>
                      </ng-container>

                      <ng-container *ngFor="let item of options">
                        <ng-container *ngIf="item.type === 'city'">
                          <mat-option disabled style="background-color: #f4f4f4;height: 42px;" *ngIf="item.cities && item.cities.length > 0">
                            <div class="d-flex justify-content-between">
                              <div class="d-flex align-items-center" style="gap: 0.25em;">
                                <img src="../../../../assets/icons/search-box/ubicacion_gris.svg" style="width: 35px; height: 35px;">
                                <span class="mt-1" style="font-family: 'Rubik', serif; font-size: 13px !important; font-weight: 600 !important;">Ubicación</span>
                              </div>
                              <div>
                                <span style="font-family: 'Rubik', serif; font-size: 11px !important; font-weight: 400 !important;">{{item.cities.length}} resultados</span>
                              </div>
                            </div>
                          </mat-option>
                          <ng-container *ngFor="let city of item.cities">
                            <mat-option [value]="{data: city, type: item.type}">
                              <div style="margin-left: 2.4em;">
                                  <p class="mb-0" style="font-family: 'Rubik'; font-size: 14px !important; font-weight: 600 !important; line-height: 1;">{{ capitalize(city.main_text) }},
                                  <span class="mb-0" style="font-family: 'Rubik'; font-size: 12px !important; line-height: 1;font-weight: 400 !important;">{{ capitalize(city.secondary_text) }}</span>
                                </p>
                              </div>
                            </mat-option>
                          </ng-container>
                      </ng-container>
                    </ng-container>



                    </ng-container>

                 </mat-autocomplete>
                <span
                  style="color: red; font-family: 'Poppins'; font-size: 10px !important; position: absolute; bottom: -16px; left: 10px; line-height: 1;"
                  *ngIf="leg.get('destination').touched && leg.get('destination').hasError('required')"
                >Este campo es requerido. Seleccione un destino válido de la lista.</span>
            </div>
            </div>

          <div id="form-destination" style="width:20%">
              <div class="position-relative">
                 <input
                      [formControl]="$any(leg.get('date'))"
                      type="text"
                      class="form-control input-search-box"
                      placeholder="{{selectedNoDateDefined ? 'Sin fecha' : 'Fecha'}}"
                      autocomplete="off"
                      bsDatepicker
                      [minDate]="now"
                      [bsConfig]="dpConfig"
                      readonly
                    />
                 <span
                   style="color: red; font-family: 'Poppins'; font-size: 10px !important; position: absolute; bottom: -16px; left: 10px; line-height: 1;"
                   *ngIf="leg.get('date').touched && leg.get('date').hasError('required')"
                 >Este campo es requerido.</span>
              </div>
          </div>

          <button *ngIf="i > 0"
                  type="button"
                  class="close btn-closed"
                  style="flex: 0 0 auto;"
                  (click)="removeLeg(i)"
                  aria-label="Quitar tramo">
            <span aria-hidden="true" style="font-size: 24px;">&times;</span>
          </button>
        </div>
      </ng-container>

    </ng-container>

    <!-- Agregar tramo + Clase de cabina + Pasajeros + botón de búsqueda (multidestino) -->
    <div class="d-flex mb-3 mt-3" style="gap: .5em;" *ngIf="selectedWay === 'multi'">
      <div style="width:20%">
        <button type="button"
                class="btn btn-segment-new"
                (click)="addLeg()">
          <p>+ Agregar tramo</p>
        </button>
      </div>

      <div id="form-destination " style="width:20%; position: relative">
        <select
          formControlName="cabinClass"
          class="form-control input-search-box select-style"
          style="height: 100%;"
        >
          <option value="">Clase de cabina</option>
          <ng-container *ngFor="let cabin of cabinClassArr">
            <option [value]="cabin.value">{{ cabin.label }}</option>
          </ng-container>
        </select>

        <img
            width="10"
            height="10"
            style="position: absolute; right: 1em; top: 30%"
            src="../../../../../assets/img/app/little-icons/arrow-down-black.svg"
          />
      </div>

      <div  id="form-destination" style="width: 35%">
         <div class="position-relative">
           <button
            #triggerButton
            type="button"
            class="form-control btn-usb-rp d-flex align-items-center justify-content-between element-config-passenger"
            (click)="_openModal();"
            [attr.aria-expanded]="!isCollapsed"
            aria-controls="false"
          >
            <p class="p-0 m-0 align-self-center align-middle font-poppins text-passenger-input"> {{ passengers }}</p>

            <img width="10" height="10" src="../../../../../assets/img/app/little-icons/arrow-down-black.svg" />
          </button>

          <div
            (collapsed)="clickOutside($event)"
            (expanded)="($event)"
            [collapse]="!isCollapsed || _close"
            (click)="_over()"
            class="config-passenger"
          >
            <div class="row">
              <div style="position: relative; width: 100%">
                <div
                  #cardSelectorRoom
                  id="cardSelectorRoomMulti"
                  class="card py-4 px-4 scrollable-card-container"
                  style="width: auto !important; min-width: 100%"
                >
                  <div class="room-content">
                    <div class="d-flex flex-row col-12 align-items-center justify-content-between p-2">
                      <div class="d-flex flex-column">
                        <div class="d-flex flex-row align-items-start justify-content-between p-0 pb-3" formGroupName="passengers">
                          <div class="d-flex flex-column align-items-center p-0 m-0 mr-2 ml-3">
                            <div class="d-flex flex-column align-items-start mb-3">
                              <label class="mb-0" style="font-family: 'Rubik' !important; font-size: 14px !important; font-weight: 600 !important; line-height: 1;">Adultos</label>
                              <p class="mb-0" style="font-family: 'Rubik' !important; font-size: 11px !important; font-weight: 400 !important; line-height: 1;">+ de 18 años</p>
                            </div>
                            <div class="input-group justify-content-end" style="max-width: 200px; width: 100%; min-width: 91px">
                              <button type="button" class="pr-2" style="border: none; background-color: transparent;" (click)="decrementPassengerAdult($event)" [disabled]="getPassengerCountAdult() <= 1">
                                <p class="mb-0" style="font-size: 20px; font-weight: 700 !important;">-</p>
                              </button>
                              <input
                                type="number"
                                class="form-control text-center"
                                style="border-radius: 8px; max-width: 45px; padding: 0 !important;"
                                [value]="getPassengerCountAdult()"
                                [min]="1"
                                [max]="10"
                                (change)="validatePassengerInput($event)"
                                (keydown)="handleAdultInput($event)"
                                (blur)="handleAdultBlur($event)"
                                (click)="preventModalClose($event)"
                                name="adults"
                              />
                              <button type="button" class="pl-2" style="border: none; background-color: transparent;" (click)="incrementPassengerAdult($event)" [disabled]="getPassengerCountAdult() >= 10">
                                <p class="mb-0" style="font-size: 20px; font-weight: 700 !important;">+</p>
                              </button>
                            </div>
                          </div>
                          <div class="d-flex flex-column align-items-center p-0 m-0 mr-3 ml-2">
                            <div class="container-label d-flex mb-3">
                              <div class="d-flex flex-column align-items-start">
                                <label class="mb-0" style="font-family: 'Rubik' !important; font-size: 14px !important; font-weight: 600 !important; line-height: 1;">Niños</label>
                                <p class="mb-0" style="font-family: 'Rubik' !important; font-size: 11px !important; font-weight: 400 !important; line-height: 1;">- de 18 años</p>
                              </div>
                            </div>
                            <div class="input-group justify-content-end" style="max-width: 200px; width: 100%; min-width: 91px">
                              <button type="button" style="border: none; background-color: transparent;" class="pr-2" (click)="decrementPassengerChildren($event)" [disabled]="getPassengerCountChildren() <= 0">
                                <p class="mb-0" style="font-size: 20px; font-weight: 700 !important;">-</p>
                              </button>
                              <input
                                type="number"
                                class="form-control text-center"
                                style="border-radius: 8px; max-width: 45px; padding: 0 !important;"
                                [value]="getPassengerCountChildren()"
                                [min]="0"
                                [max]="10"
                                (change)="validatePassengerInput($event)"
                                (keydown)="handleChildrenInput($event)"
                                (blur)="handleChildrenBlur($event)"
                                (click)="preventModalClose($event)"
                                name="children"
                              />
                              <button type="button" style="border: none; background-color: transparent;" class="pl-2" (click)="incrementPassengerChildren($event)" [disabled]="getPassengerCountChildren() >= 10">
                                <p class="mb-0" style="font-size: 20px; font-weight: 700 !important;">+</p>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="formArray(passengersGroup, 'childsage').length > 0" formGroupName="passengers" class="d-flex flex-column p-4 m-0" style="border-radius: 10px; background-color: #f4f4f4;">
                          <div class="d-flex flex-column align-items-start mb-3 ml-1">
                            <label class="mb-0" style="font-family: 'Rubik' !important; font-size: 14px !important; font-weight: 600 !important; line-height: 1; text-wrap: nowrap;">Edad niños <span style="font-weight: 400 !important;">- de 18 años</span></label>
                          </div>
                          <div class="d-flex mb-4 flex-wrap">
                            <div formArrayName="childsage" *ngFor="let age of formArray(passengersGroup, 'childsage'); let j = index">
                              <label [formGroupName]="j" class="p-0 ml-1" style="position: relative;">
                                <select
                                  name="age"
                                  formControlName="age"
                                  [ngStyle]="{'margin-left': j > 0 ? '1em' : ''}"
                                  class="form-control custom-select-arrow"
                                  style="height: 35px !important; padding: 0 !important; width: 60px !important; font-family: 'Rubik' !important; font-size: 14px !important; font-weight: 600 !important; text-align: left; padding-left: 13px !important; background-color: #FFFFFF !important; border-radius: 12px;"
                                >
                                  <ng-container *ngFor="let value of agesChildsArr()">
                                    <option value="{{ value }}">{{ value }}</option>
                                  </ng-container>
                                </select>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex flex-row justify-content-end py-2">
                          <div class="py-2 justify-content-end">
                            <button
                              (click)="_confirm()"
                              [attr.aria-expanded]="!isCollapsed"
                              aria-controls="false"
                              class="badge btn-choice-confirm"
                              style="border: none; min-width: 145px; width: 100%; height: 36px;"
                              type="button"
                              [ngStyle]="{'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                            >
                              Confirmar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
         </div>
      </div>

      <div id="form-destination" class="d-flex" *ngIf="userService.itineraryActive">

          <button *ngIf="!userService._isGuest && userService.itineraryActive.length === 0"
                  class="btn btn-search-hotel d-flex justify-content-center align-items-center inp"
                  (click)="fileActive()"
                  [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                  type="button">
            <span>BUSCAR</span>
          </button>
          <button *ngIf="!userService._isGuest && userService.itineraryActive.length > 0 && validateButtonSearch"
                class="btn btn-search-hotel d-flex justify-content-center align-items-center inp w-100"
                (click)="filePaid()"
                [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                type="button">
          <span>BUSCAR</span>
        </button>
          <button *ngIf="userService._isGuest || (userService.itineraryActive.length > 0 && !validateButtonSearch)"
                  class="btn btn-search-hotel d-flex justify-content-center align-items-center inp"
                  [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                  [disabled]="!_form.valid"
                  type="submit">
            <span>BUSCAR</span>
          </button>
    </div>
    </div>

    <div class="d-flex mb-3 mt-3" style="gap: .25em;">
      <div class="d-flex align-items-center w-100 position-relative justify-content-center" style="gap: .5em;" id="form-destination">
        <input
          type="checkbox"
          (change)="noDateDefined($event)"
          [checked]="selectedNoDateDefined">
        <p class="mb-0" style="font-family: 'Rubik', sans-serif !important;font-size: 12px !important;font-weight: 400 !important;color: black;line-height: 1;">
          Todavía no tengo fecha definida
        </p>
      </div>
    </div>

  </form>



</div>


<div class="modal" [ngClass]="{ show: showModal }">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header d-flex align-items-center justify-content-end" [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }" style="padding: 5px !important;">
        <button type="button" class="close-btn" aria-label="Close" (click)="confirmAction()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <div class="modal-body">
        <img src="../../../../../assets/icons/itinerary-detail/ALERTA-01.svg" width="40" />

        <h5 class="modal-title mt-2 text-black">{{ titleModal }}</h5>
        <p class="mb-1 modal-body-text">
          <span style="font-weight: 500">Cree un file</span> <br />
          en la barra superior para poder <br /> iniciar una busqueda
        </p>
      </div>
    </div>
  </div>
</div>
